import { SVGProps } from 'react';

const List = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 12h.01M3 18h.01M3 6h.01M8 12h13M8 18h13M8 6h13"
    />
  </svg>
);
export default List;
